"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var interfaces_1 = require("@hudled/interfaces");
// import BillingPlan from './BillingPlan';
// import DormantUsers from './DormantUsers';
var ForexCosts_1 = __importDefault(require("./ForexCosts"));
// import Partnership from './Partnership';
// import UnusedSaaS from './UnusedSaaS';
// import OfferAlternativeProducts from './OfferAlternativeProducts';
var NegotiateForHighExpenditure_1 = __importDefault(require("./NegotiateForHighExpenditure"));
var COMPONENT_MAP = (_a = {},
    // [RECOMMENDATIONS_TYPE.PAPR]: Partnership,
    _a[interfaces_1.RECOMMENDATIONS_TYPE.FX] = ForexCosts_1.default,
    // [RECOMMENDATIONS_TYPE.USUB]: UnusedSaaS,
    // [RECOMMENDATIONS_TYPE.DORM]: DormantUsers,
    // [RECOMMENDATIONS_TYPE.M2Y]: BillingPlan,
    // [RECOMMENDATIONS_TYPE.ALT]: OfferAlternativeProducts,
    _a[interfaces_1.RECOMMENDATIONS_TYPE.NEGOT] = NegotiateForHighExpenditure_1.default,
    _a);
var OptimiseDetails = function (_a) {
    var recommendation = _a.recommendation, onClickClose = _a.onClickClose;
    var Component = COMPONENT_MAP[recommendation.type];
    if (Component) {
        return ((0, jsx_runtime_1.jsx)(Component, { recommendation: recommendation, serviceStat: recommendation.serviceStat, onClickClose: onClickClose }));
    }
    return null;
};
exports.default = OptimiseDetails;
